export default "__VITE_ASSET__DJ09MenZ__"